// removed by extract-text-webpack-plugin
module.exports = {"container":"_2G4-W8AFPuEpf5cJh-oaLJ","title":"Dl48qvFNB5xioGsu_W4w","icon":"_2KQM4Z98xpEsSS_t3LedH4","form":"_3bMBYPM8w_3IYYyLu2vEZz","button":"zoWzR_sM0mqwXjRGevBsI","code":"-dHItvO8ZZ46C7UrlxbS9"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/styles.css
// module id = 3013
// module chunks = 0